import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  mainTitle: {
    defaultMessage: 'Import your inventory counts',
    id: '4xToy/',
    description: 'Main title displayed at the top of the result import step',
  },
  titleDescription: {
    defaultMessage: "To get started, you'll import your products and their stock counts using a single CSV upload.",
    id: 'e5mT7p',
    description: 'Descriptive text displayed below the main title explaining the import process',
  },
  importAnotherFile: {
    defaultMessage: 'Import another file',
    id: 'pA/9ZG',
    description: 'Button text for importing another file after the current import is complete or in progress',
  },
});

export const importMessages = defineMessages({
  importHeader: {
    defaultMessage: 'Import products',
    id: '6ha+ms',
    description: 'Title displayed in the import drawer header',
  },
  uploadFile: {
    defaultMessage: 'Upload File',
    id: 'mHr/Xd',
    description: 'Title for the file upload step in the import process',
  },
  matchFields: {
    defaultMessage: 'Match Fields',
    id: 'JKtV1W',
    description: 'Title for the field mapping step in the import process',
  },
  importResult: {
    id: 'h/jSfc',
    defaultMessage: 'Import Products',
    description: 'Title for the step showing import processing status',
  },
  importResultSuccess: {
    id: 'q/BqS9',
    defaultMessage: 'Products Successfully Imported',
    description: 'Title displayed when inventory import completes successfully',
  },
});
